import React, { Component } from 'react';
import { Noun, Verb, trackUe } from '@trello/analytics';
import { PrimaryButton } from 'app/common/components/controls/button/button';
import styles from './LinkCopy.less';
import { forNamespace } from 'app/common/lib/util/i18n';
const format = forNamespace('link copy');

interface LinkCopyProps {
  shortUrl: string;
  eventCategory: Noun;
  boardId?: string;
  teamId?: string;
}

export class LinkCopy extends Component<LinkCopyProps, { buttonText: string }> {
  linkInput = React.createRef<HTMLInputElement>();
  timer: number;

  state = {
    buttonText: format('copy'),
  };

  componentWillUnmount() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }

  getEventContext = () => {
    return {
      boardId: this.props.boardId || '',
      teamId: this.props.teamId || '',
    };
  };

  handleButtonClick = () => {
    if (this.linkInput.current) {
      this.linkInput.current.select();
      document.execCommand('copy');
      this.setState({ buttonText: format('copied') });
    }

    // Create a timeout to change "Copied!" back to "Copy" as a visual indicator
    // that the link has successfully completed being copied to the clipboard
    this.timer = window.setTimeout(() => {
      this.setState({ buttonText: format('copy') });
    }, 2000);

    trackUe({
      category: this.props.eventCategory,
      verb: Verb.COPIES,
      directObj: Noun.BOARD_SHORT_URL,
      method: 'by clicking on the copy button',
      context: this.getEventContext(),
    });
  };

  handleInputClick = () => {
    if (this.linkInput.current) {
      this.linkInput.current.select();
    }

    trackUe({
      category: this.props.eventCategory,
      verb: Verb.HIGHLIGHTS,
      directObj: Noun.BOARD_SHORT_URL,
      prepositionalObj: 'in input box',
      method: 'by clicking on it',
      context: this.getEventContext(),
    });
  };

  render() {
    return (
      <div className={styles.shareLinkContainer}>
        <input
          readOnly
          value={this.props.shortUrl}
          onClick={this.handleInputClick}
          ref={this.linkInput}
        />
        <PrimaryButton
          title={this.state.buttonText}
          onClick={this.handleButtonClick}
        >
          {this.state.buttonText}
        </PrimaryButton>
      </div>
    );
  }
}
